export default __webpack_public_path__ + "static/media/HOLD 1.bc7d71a6.mp3";